import ViewModel from "pattern/view_model";

export default class SpeakerViewModel extends ViewModel {
    /**
     * @param {String} id the id of the person (unique)
   * @param {String} name the name of the committee member.
   * @param {String} image the path of the committee member image.
   */
    constructor(id, name, image) {
        super();

        this.id = id;
        this.name = name;
        this.image = image;
    }
}

/**
 * Creates a new instance of the {@link SpeakerViewModel}.
 *
 * @param {Object} kwargs
 * @param {String} kwargs.id
 * @param {String} kwargs.name
 * @param {String} kwargs.image
 *
 * @returns {SpeakerViewModel} the new instance.
 */
const create = ({
    id = '',
    name = '',
    image = '',
} = {}) => new SpeakerViewModel(
    id,
    name,
    image,
);

const convert = (model) => {
    if (typeof model.id !== 'string') {
        throw new Error('the model.id is not valid');
    }
    if (typeof model.name !== 'string') {
        throw new Error('the model.name is not valid');
    }
    if (typeof model.image !== 'string') {
        throw new Error('the model.image is not valid');
    }

    return new SpeakerViewModel(
        model.id,
        model.name,
        model.image,
    );
};

export const speakerViewModelFactory = {
    create,
    convert,
};